import { Injectable } from '@angular/core';

@Injectable()

export class Globals {
  isInitialLogin: number = 1;
  isLeadershipBoard: number = 0;
  isAssignment: number = 0;
  isTrainingProgram: number = 0;
  isTraining: number = 0;
  isQuestionnaire: number = 0;
  isSurvey: number = 0;
  isRecognition: number = 0;
  isUserGuide: number = 0;
  theme: string = "default";
  themeFont: string = "default";
  approvalCountChange:number = 0;
  showUserList:number = 0;
  returnUrl:any = '';
  returnQueryParams:any = {};
}



// WEBPACK FOOTER //
// /app/src/app/services/globals.ts